<template>
    <div style="overflow: hidden;width: 100%">
        <CommonHeader />
        <div class="container" style="min-height: calc(100vh - 56px - 88px);">
            <a-row>
                <a-col class="mt-3 mb-5" :span="24">
                    <a-breadcrumb>
                        <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
                        <a-breadcrumb-item>认证</a-breadcrumb-item>
                    </a-breadcrumb>
                </a-col>
            </a-row>
            <a-page-header>
                <template v-slot:content>
                    将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。
                </template>
                <a-card :bordered="false">
                    <a-steps class="steps" :current="currentTab">
                        <a-step title="填写单位信息" />
                        <a-step title="填写详细信息" />
                        <a-step title="提交审核" />
                    </a-steps>
                    <div class="content">
                        <LegalCertificatStep1 v-if="currentTab === 0" @nextStep="nextStep" @clickSupplier="clickSupplier" @commitValue = "commitValue"/>
                        <LegalCorporateStep2 :key="coKey" v-if="CorporateVisible" @nextStep="nextStep" @prevStep="prevStep" :enterpriseCode="enterpriseCode" :enterpriseName="enterpriseName"/>
<!--                        <IndividualBusiness  :key="inKey" v-if="IndividualVisible"  @nextStep="nextStep" @prevStep="prevStep" :enterpriseCode="enterpriseCode" :enterpriseName="enterpriseName"/>-->
                        <CertificateFinished v-if="currentTab === 2" @prevStep="prevStep" @finish="finish"/>
                    </div>
                </a-card>
            </a-page-header>
        </div>
        <CommonFooter />
    </div>
</template>

<script>
    import LegalCertificatStep1 from './LegalCertificatStep1'
    // import IndividualBusiness from './IndividualStep2'
    import LegalCorporateStep2 from './LegalCorporateStep2'
    import CertificateFinished from './CertificateStep3'
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'

    // *****************************法人供应商认证界面*****************************
    export default {
        name: 'LegalCertificationIndex',
        components: {
            CertificateFinished,
            CommonHeader,
            // IndividualBusiness,
            LegalCorporateStep2,
            CommonFooter,
            LegalCertificatStep1
        },
        data () {
            return {
                currentTab: 0,
                // form
                form: null,
                enterpriseCode:'',
                enterpriseName: '',
                supplierType: '',
                key: '',
                coKey: '',
                inKey: '',
                CorporateVisible: false,
                IndividualVisible: false
            }
        },
        methods: {
            nextStep () {
                if (this.currentTab < 2) {
                    this.currentTab += 1;
                }
                if (this.currentTab === 1) {
                    if (this.supplierType === "2") {
                        this.CorporateVisible = true
                        this.IndividualVisible = false
                    }else if (this.supplierType === "1") {
                        this.CorporateVisible = false
                        this.IndividualVisible = true
                    }
                }else {
                    this.CorporateVisible = false
                    this.IndividualVisible = false
                }
            },
            prevStep () {
                if (this.currentTab > 0) {
                    this.currentTab -= 1
                }
                if (this.currentTab == 0) {
                    this.IndividualVisible = false
                    this.CorporateVisible = false
                }
            },
            finish () {
                this.currentTab = 0
            },
            commitValue(code,name) {
                console.log(code + "  " + name )
                this.enterpriseCode = code
                this.enterpriseName = name
            },
            clickSupplier(supplierType) {
                this.supplierType = supplierType
                console.log("supplierType" + this.supplierType)
            }
        }
    }
</script>

<style lang="less" scoped>
    .steps {
        max-width: 750px;
        margin: 16px auto;
    }
</style>
